import React, { useEffect, useState, useRef, useMemo } from "react";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  Input
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from "axios";
import moment from "moment";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const API_NEWS = "https://deneme.stechomeyazilim.info/api/v1/news";
const API_NOTIFICATIONS = "/Notification?$format=json&$top=1000";
const API_BASE = "https://mansethaberapi.stechomeyazilim.com";
const API_SEND_NOTIFICATION = `${API_BASE}/BILDIRIM_LOGLARI`;
const API_SAVE_NOTIFICATION = "/Notification";
const API_TITLE_TEMPLATES = `${API_BASE}/BILDIRIM_BASLIKLARI?$format=json&$top=100&$orderby=SIRA asc`;

const SOUND_OPTIONS = [
  { value: "default", label: "Varsayılan" },
  { value: "breaking", label: "Son Dakika" },
  { value: "soft", label: "Yumuşak" },
  { value: "chime", label: "Çan" },
];

const ContactsList = () => {
  document.title = "Haberler | Manşet Haber ADMIN PANELI";
  const tableRef = useRef(null);

  const [news, setNews] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [sending, setSending] = useState({});
  const [selectedSounds, setSelectedSounds] = useState({});
  const [selectedTitles, setSelectedTitles] = useState({});
  const [titleTemplates, setTitleTemplates] = useState([]);

  const setSendingOn = (id) => setSending((prev) => ({ ...prev, [id]: true }));
  const setSendingOff = (id) => setSending((prev) => ({ ...prev, [id]: false }));

  const fetchNews = async () => {
    try {
      const res = await fetch(`${API_NEWS}?page=1&per_page=100`);
      const json = await res.json();
      return json.success && Array.isArray(json.data) ? json.data : [];
    } catch (error) {
      console.error("Haber verileri alınamadı", error);
      return [];
    }
  };

  const fetchNotifications = async () => {
    try {
      const res = await fetch(API_NOTIFICATIONS);
      const text = await res.text();
      if (!text) return [];
      const json = JSON.parse(text);
      if (json && json.value && Array.isArray(json.value)) return json.value;
      if (Array.isArray(json)) return json;
      if (json && Array.isArray(json.data)) return json.data;
      return [];
    } catch (error) {
      console.error("Bildirim verileri alınamadı", error);
      return [];
    }
  };

  const loadData = async () => {
    const newsData = await fetchNews();
    const notifData = await fetchNotifications();
    setNotifications(notifData);

    const updatedNews = newsData
      .map((item) => ({
        ...item,
        hasNotification: notifData.some(
          (n) => String(n.post_id) === String(item.id)
        ),
      }))
      // En son eklenen haberler ilk sayfada görünsün (id'ye göre azalan)
      .sort((a, b) => Number(b.id) - Number(a.id));
    setNews(updatedNews);
  };

  useEffect(() => {
    loadData();
  }, []);

  // Standart bildirim başlıklarını çek (admin panelinden yönetilir)
  useEffect(() => {
    const fetchTitleTemplates = async () => {
      try {
        const res = await fetch(API_TITLE_TEMPLATES);
        const json = await res.json();
        const list = json && Array.isArray(json.value) ? json.value : [];
        setTitleTemplates(list.filter((t) => t.AKTIF !== false));
      } catch (error) {
        console.error("Başlık şablonları alınamadı:", error);
      }
    };
    fetchTitleTemplates();
  }, []);

  const showToast = (success, message) => {
    toastr.options = {
      positionClass: "toast-top-right",
      timeOut: 5000,
      closeButton: true,
      progressBar: true,
    };
    if (success) toastr.success(message, "Başarılı");
    else toastr.error(message, "Hata");
  };

  const postNotificationRecord = async (item) => {
    try {
      await axios.post(API_SAVE_NOTIFICATION, {
        thumbnail_url: item.featured_image || "",
        post_title: "Manşet Haber " + item.title,
        post_date: moment(item.publish_date).format("YYYY-MM-DDTHH:mm:ssZ"),
        post_id: Number(item.id),
        category: item.category?.name || "Genel",
      });
    } catch (err) {
      console.error("Kayıt hatası:", err);
    }
  };

  const handleSendAll = async (item, sound, title) => {
    const postId = Number(item.id);
    setSendingOn(postId);
    try {
      await axios.post(API_SEND_NOTIFICATION, {
        KULLANICI_ID: 0,
        BASLIK: (title && title.trim()) || item.category?.name || "Manşet Haber",
        ICERIK: item.title,
        thumbnail_url: item.featured_image || "",
        GONDERIM_TARIHI: moment().toISOString(),
        OKUNDU: false,
        TIP: "haber",
        ILGILI_ID: Number(item.id),
        SES: sound || "default"
      });
      await postNotificationRecord(item);
      showToast(true, "Bildirim tüm kullanıcılara gönderildi.");
      loadData();
    } catch (error) {
      console.error("Bildirim hatası:", error);
      showToast(false, "Bildirim gönderilirken hata oluştu.");
    } finally {
      setSendingOff(postId);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: ({ row }) => <span>{row.index + 1}</span>,
      },
      {
        Header: "Foto",
        disableFilters: true,
        accessor: (cellProps) =>
          cellProps.featured_image ? (
            <img
              className="avatar-xl"
              src={cellProps.featured_image}
              alt=""
              style={{ objectFit: "cover", borderRadius: 4 }}
            />
          ) : (
            <div className="avatar-xs">
              <span className="avatar-title">
                {cellProps.title?.charAt(0)}
              </span>
            </div>
          ),
      },
      {
        Header: "Tarih",
        accessor: "publish_date",
        filterable: true,
        Cell: ({ value }) =>
          value ? moment(value).format("DD.MM.YYYY HH:mm") : "-",
      },
      {
        Header: "Kategori",
        accessor: "category.name",
        filterable: true,
        Cell: ({ row }) => (
          <Badge color="info" className="font-size-11">
            {row.original.category?.name || "-"}
          </Badge>
        ),
      },
      {
        Header: "Haber Adı",
        accessor: "title",
        filterable: true,
      },
      {
        Header: "Okunma",
        accessor: "views",
        Cell: ({ value }) => (
          <span className="badge bg-success">{value || 0}</span>
        ),
      },
      {
        Header: "Yorum",
        accessor: "comment_count",
        Cell: ({ value }) => (
          <span className="badge bg-primary">{value || 0}</span>
        ),
      },
      {
        Header: "Bildirim",
        accessor: "hasNotification",
        Cell: ({ value }) =>
          value ? (
            <span className="badge bg-success">Aktif</span>
          ) : (
            <span className="badge bg-danger">Pasif</span>
          ),
      },
      {
        Header: "İşlemler",
        Cell: ({ row }) => {
          const item = row.original;
          const postId = Number(item.id);
          const isSending = !!sending[postId];

          if (item.hasNotification) {
            return (
              <span className="badge bg-secondary">Bildirim olarak gönderildi</span>
            );
          }

          const sound = selectedSounds[postId] || "default";
          // Varsayılan başlık "Sıcak Haber"; kullanıcı kategori (varsayılan) veya
          // başka bir başlık seçerse o geçerli olur.
          const titleVal =
            selectedTitles[postId] !== undefined
              ? selectedTitles[postId]
              : "Sıcak Haber";
          return (
            <div className="d-flex gap-2 align-items-center flex-wrap">
              <Input
                type="select"
                bsSize="sm"
                style={{ width: 150 }}
                value={titleVal}
                onChange={(e) => {
                  const v = e.target.value;
                  setSelectedTitles((prev) => ({ ...prev, [postId]: v }));
                  // Başlık şablonu seçilince varsayılan sesini otomatik uygula
                  const tpl = titleTemplates.find((t) => t.BASLIK === v);
                  if (tpl && tpl.SES) {
                    setSelectedSounds((prev) => ({ ...prev, [postId]: tpl.SES }));
                  }
                }}
              >
                <option value="">
                  {item.category?.name || "Manşet Haber"} (varsayılan)
                </option>
                {titleTemplates.map((t) => (
                  <option key={t.ID || t.BASLIK} value={t.BASLIK}>
                    {t.BASLIK}
                  </option>
                ))}
              </Input>
              <Input
                type="select"
                bsSize="sm"
                style={{ width: 120 }}
                value={sound}
                onChange={(e) =>
                  setSelectedSounds((prev) => ({ ...prev, [postId]: e.target.value }))
                }
              >
                {SOUND_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Input>
              <button
                type="button"
                className="btn btn-sm btn-success d-flex align-items-center"
                disabled={isSending}
                onClick={() => handleSendAll(item, sound, titleVal)}
              >
                {isSending ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" />
                    Gönderiliyor...
                  </>
                ) : (
                  <>
                    <i className="mdi mdi-checkbox-blank font-size-16 me-1" />
                    Herkese Gönder
                  </>
                )}
              </button>
            </div>
          );
        },
      },
    ],
    [sending, selectedSounds, selectedTitles, titleTemplates]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Haber Listesi" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={news}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddUser={false}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
